(function($) {

  // defaults
  var theme_options = {
    ajaxUrl: '',
    themeUrl: '',
    security: '',
    clawMessage: 'Vi använder cookies för att förbättra upplevelsen och anpassa vår marknadsföring. Genom att surfa vidare godkänner du detta.',
    clawLinkUrl: '#',
    clawLinkText: 'Läs mer',
    clawBtnText: 'Jag förstår'
  };

  if (typeof theme_vars !== 'undefined') {
    jQuery.extend(theme_options, theme_vars);
  }

  var theme = {
    // initialize
    init: function() {
      this.offCanvas();
      this.navigation();
      this.cookiesNotice();
      this.waypoints();
      this.polyfill();
    },

    // off canvas
    offCanvas: function() {
      // toggle
      $('.js-off-canvas-toggle').click(function(e) {
        e.preventDefault();
        $('body').toggleClass('off-canvas-visible');
      });
    },

    // navigation
    navigation: function() {
      // prevent scroll on '#'
      $('.nav-primary a[href="#"]').click(function(e) {
        e.preventDefault();
      });
    },

    // cookies
    cookiesNotice: function() {
      cmClaw.init({
        message: theme_options.clawMessage,
        linkUrl: theme_options.clawLinkUrl,
        linkText: theme_options.clawLinkText,
        btnText: theme_options.clawBtnText
      });
    },

    // waypoints
    waypoints: function() {
      var waypoint = new Waypoint({
        element: $('body'),
        handler: function() {
          $('body').toggleClass('-scrolled');
        },
        offset: -1
      });
    },

    // polyfill
    polyfill: function() {
      // svg 4 everybody
      svg4everybody();
    }
  }

  // initialize
  theme.init();

})(jQuery);